var map = {
	"./avl/avl.js": 23868,
	"./avl/avl2.js": 42673,
	"./avl/backup.js": 73155,
	"./avl/backup2.js": 92874,
	"./avl/backup3.js": 63343,
	"./avl/backup4.js": 71156,
	"./avl/backup5LATEST.js": 23258,
	"./bellmanford/bellmanford.js": 11486,
	"./binarysearch/binarysearch.js": 36334,
	"./binarysearchtree/binarysearchtree.js": 37438,
	"./binarysearchtree/binarysearchtree2.js": 93738,
	"./breadthfirstsearch/breadthfirstsearch.js": 78171,
	"./bubblesort/bubblesort.js": 9616,
	"./depthfirstsearch/depthfirstsearch.js": 59788,
	"./dijkstras/dijkstras.js": 67934,
	"./fibonaccisequence/fibonaccisequence.js": 68886,
	"./floodfill/floodfill.js": 26594,
	"./hashtable/hashtable.js": 66738,
	"./hashtablelinkedlist/hashtablelinkedlist.js": 94003,
	"./hashtablequadratic/hashtablequadratic.js": 91647,
	"./heaps/heaps.js": 37204,
	"./heaps/heaps1.js": 64826,
	"./heapsort/heapsort.js": 87017,
	"./huffmancodingtree/huffmancodingtree.js": 37276,
	"./inorder/inorder.js": 3793,
	"./insertionsort/insertionsort.js": 3753,
	"./kruskals/kruskals.js": 8633,
	"./linearsearch/linearsearch.js": 44297,
	"./mergesort/mergesort.js": 4552,
	"./nqueens/nqueens.js": 83718,
	"./postorder/postorder.js": 79081,
	"./preorder/preorder.js": 6187,
	"./prims/prims.js": 77609,
	"./quicksort/quicksort.js": 20041,
	"./selectionsort/selectionsort.js": 35757,
	"./singlylinkedlist/singlylinkedlist.js": 98980,
	"./towersofhanoi/towersofhanoi.js": 88170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53102;